import { render, staticRenderFns } from "./practicalExplorationInfo.vue?vue&type=template&id=219eda50&"
import script from "./practicalExplorationInfo.vue?vue&type=script&lang=js&"
export * from "./practicalExplorationInfo.vue?vue&type=script&lang=js&"
import style0 from "./practicalExplorationInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports